function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.71 7.07h-4.5v3.047h5.282V12H.867V.625h7.61v1.898H3.21v2.711h4.5V7.07zM19.118 12h-2.344l-4.562-7.484V12H9.867V.625h2.344l4.57 7.5v-7.5h2.336V12z",
  fill: "#fff"
});

function SvgLangEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    fill: "none"
  }, props), _ref);
}

export default SvgLangEn;